module.exports = __webpack_public_path__ + "img/index-ico10.934785ee.png";